// Remembers which link brought a visitor (UTM labels, a Google Ads click, or the site they came from) so that, if they register,
// the account is saved with its source. Only short labels are stored (never a name, phone or email) and only in this browser for 30 days.
const KEY = 'gettimelam_source';
const DAYS = 30;
const OWN_HOSTS = ['gettimelammatrimony.com', 'localhost', '127.0.0.1'];

const read = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (saved && saved.source && saved.at && Date.now() - saved.at < DAYS * 864e5) return saved;
    } catch (error) { /* storage can be blocked: nothing to remember */ }
    return null;
};

const write = (value) => {
    try { localStorage.setItem(KEY, JSON.stringify({ ...value, at: Date.now() })); } catch (error) { /* ignore */ }
};

// called once when the site opens
export const captureAttribution = () => {
    try {
        const params = new URLSearchParams(window.location.search);
        const utm = {
            source: params.get('utm_source'), medium: params.get('utm_medium'), campaign: params.get('utm_campaign'),
            content: params.get('utm_content'), term: params.get('utm_term'),
        };
        const landingPath = window.location.pathname;
        if (utm.source) { write({ ...utm, landingPath }); return; } // a labelled link always wins
        if (params.get('gclid')) { write({ source: 'google', medium: 'cpc', landingPath }); return; }
        if (read()) return; // keep what we already know
        const host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : '';
        if (host && !OWN_HOSTS.some(own => host === own || host.endsWith(`.${own}`))) {
            write({ source: host, medium: /(^|\.)(google|bing|yahoo|duckduckgo)\./.test(`.${host}.`) ? 'organic' : 'referral', landingPath });
        }
    } catch (error) { /* never break the page */ }
};

// what is sent with a registration (nothing when the visitor arrived without a known source)
export const getAttribution = () => {
    const saved = read();
    if (!saved) return undefined;
    const { at, ...labels } = saved;
    return labels;
};
